<template>
  <div class="vod-player">
    <div class="video-wrap highlight-video-wrap" v-adjust-height>
      <div class="player-top-contents">
        <div id="container" ref="container" class="video-container"></div>
      </div>
      <div class="player-bottom-contents">
        <h2>
          <span class="episode-number">{{episodeTitle}}</span>
        </h2>
        <div class="program-info-box">
          <span>{{programtitle}}</span>
          <i class="icon-dotted"/>
          <span>{{date}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { destroyPlayer, detachPlayerEvents, getUserInfo } from '@/common/utils/common'
  import { playerDelegate } from '@/common/utils/scalable.player'
  import { adjustHeight } from '@/common/resources/directives'
  export default {
    name: 'HighlightPlayer',
    props: {
      highlightInfo: {
        type: Object
      }
    },
    directives: {
      adjustHeight
    },
    computed: {
      episodeTitle () {
        return _.get(this.highlightInfo, 'episodetitle', '')
      },
      programtitle () {
        return _.get(this.highlightInfo, 'programtitle', '')
      },
      date () {
        return `${_.get(this.highlightInfo, 'releasedate', '')} (${_.get(this.highlightInfo, 'releaseweekday', '')})`
      },
      price () {
        return _.get(this.highlightInfo, 'price', '')
      }
    },
    methods: {
      playerInit () {
        getUserInfo().then((userInfo) => {
          window.playerInstance.setUserInfo(userInfo)
          window.playerInstance.load('baseballhighlight', this.highlightInfo.contentid)
        })
      }
    },
    mounted () {
      playerDelegate(this, this.$refs.container)
    },
    created () {
      this.$events.$on('title', (title) => {
        this.title = title
      })
    },
    beforeDestroy () {
      detachPlayerEvents()
      destroyPlayer()
    }
  }
</script>
<style scoped>
  .kbo .vod-player{
    margin-bottom: 0;
  }

  .kbo .vod-player .highlight-video-wrap .video-container{
    width: 1240px;
    height: 698px;
  }

  .kbo .vod-player .highlight-video-wrap{
    width: 100%;
    overflow: initial;
    height: initial;
    background-color: #1b1b1b;
  }

  .kbo .highlight-video-wrap::after{
    content: '';
    display: table;
    clear: both;
  }

  .kbo .video-wrap.highlight-video-wrap .player-bottom-contents{
    padding: 40px 0;
  }
</style>
